"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AblyImp = void 0;
const SocketClient_1 = require("../base/port/SocketClient");
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
const ably_1 = __importDefault(require("ably"));
const lodash_1 = require("lodash");
class AblyImp extends SocketClient_1.SocketClient {
    constructor(authStore, meStore, ablyStore) {
        super(authStore);
        this.authStore = authStore;
        this.meStore = meStore;
        this.ablyStore = ablyStore;
        this.socketName = "Ably";
        this.ably = undefined;
        this.channel = undefined;
        this.setup();
    }
    async setup() {
        const token = this.authStore.state.brainToken || this.authStore.state.guestToken;
        if ((0, is_blank_1.default)(token))
            return;
        await this.meStore.get();
        const permission = (0, lodash_1.find)(this.meStore.state.profile?.permissions, permission => permission.key === "ably_api_key");
        if ((0, is_blank_1.default)(permission))
            return;
        this.ably = new ably_1.default.Realtime((0, lodash_1.get)(permission, "value.0", ""));
        this.ably.connection.on(stateChange => {
            console.log("Ably connection state is " + stateChange.current);
            const isConnected = stateChange.current === "connected";
            this.ablyStore.setAblyConnected(isConnected);
        });
        await this.ably.connection.once("connected");
        console.log("Connected to Ably!");
        this.channel = this.ably.channels.get(token);
        await this.channel.attach();
        this.channel?.subscribe((msg) => {
            if ((0, lodash_1.get)(msg, "data.0") !== "acknowledge") {
                const topic = (0, lodash_1.get)(msg, "data.key.topic");
                if (topic) {
                    this.channel?.publish(token, ["acknowledge", { topic }]);
                }
            }
        });
    }
    socketOn(topic, listener) {
        this.channel?.subscribe(topic, listener);
    }
    socketOff(topic, listener = () => { }) {
        this.channel?.unsubscribe(topic, listener);
    }
    socketDisconnect() {
        this.ably?.connection.close();
    }
    async socketReconnect() {
        await this.setup();
    }
}
exports.AblyImp = AblyImp;
